import { paths } from 'shell/const';
import { navigateToUrl } from 'single-spa';

import { handleExternalRedirect } from './external-redirect';

export const DEFAULT_PATH = `/`;

function validateRedirect(redirect: string): string {
  if (/^(?:http|json|data|\/\/)/.test(redirect)) {
    return DEFAULT_PATH;
  }

  return redirect;
}

export function handleLogoutEvent(): void {
  const urlParameters = new URLSearchParams(window.location.search);
  if (urlParameters.has('origin')) {
    handleExternalRedirect(false);
  } else {
    navigateToUrl(`/${paths.LOGIN}`);
  }
}

export function handleLoginEvent(): void {
  const urlParameters = new URLSearchParams(window.location.search);

  if (urlParameters.has('redirectTo')) {
    const redirectTo: string = urlParameters.get('redirectTo') as string;
    if (redirectTo.startsWith(`/${paths.REDIRECT}`)) {
      handleExternalRedirect(true);
    } else navigateToUrl(validateRedirect(redirectTo));
  } else if (window.location.pathname.startsWith(`/${paths.LOGIN}`)) {
    navigateToUrl(DEFAULT_PATH);
  }
}

function transformAnalyticsPath(pathname: string): string | null {
  // Transform analytics site URL: /analytics/site/SITEID -> /dashboard/site/SITEID?tab=cycles
  const siteMatch = pathname.match(/^\/analytics\/site\/([^/]+)$/);
  if (siteMatch) {
    const siteId = siteMatch[1];
    return `/dashboard/site/${siteId}?tab=cycles`;
  }

  // Transform analytics device URL: /analytics/site/SITEID/device/DEVICEID -> /dashboard/device/DEVICEID?tab=cycles
  const deviceMatch = pathname.match(
    /^\/analytics\/site\/[^/]+\/device\/([^/]+)$/,
  );
  if (deviceMatch) {
    const deviceId = deviceMatch[1];
    return `/dashboard/device/${deviceId}?tab=cycles`;
  }

  return null;
}

export function handleRoutingEvent(newUrl: string, isLoggedIn: boolean) {
  if (isLoggedIn && newUrl.includes('/login')) {
    navigateToUrl(paths.BASE);
    return;
  }

  // Handle analytics URL redirects for internal navigation
  if (isLoggedIn && newUrl.includes('/analytics')) {
    try {
      const url = new URL(newUrl);
      const transformedPath = transformAnalyticsPath(url.pathname);
      if (transformedPath) {
        navigateToUrl(transformedPath);
      }
    } catch (e) {
      // If URL parsing fails, continue with normal routing
    }
  }
}
